export interface Address {
  address?: string;
  address2?: string;
  city?: string;
  zipCode?: string;
  country?: string;
}
